import Tone from 'tone';

var trackCount = 0;
var trackCount = 0;

class TrackFactory {
    constructor() {
        this.tracks = [];
        this.sends = [];
    }

    useSend() {
        if (this.sends.length === 0 || !window.explore) {
            return new Tone.Volume(-100);
        }
        return this.sends.pop();
    }

    releaseSend(send) {
        if (window.explore) {
            send.disconnect();
            send.volume.value = -100;
            this.sends.push(send);
        } else {
            send.dispose();
        }
    }

    useTrack() {
        if (this.tracks.length === 0 || !window.explore) {
            return {
                gainNode: new Tone.PanVol(),
                volumeNode: new Tone.Volume(),
                muteableNode: new Tone.Volume(),
                trackNode: new Tone.Solo(),
                trackMeter: new Tone.Meter(0.9),
                faderNode: new Tone.Gain(),
            };
        }
        return this.tracks.pop();
    }

    releaseTrack(t) {
        for (let _node in t) {
            let node = t[_node];
            if (window.explore) {
                node.disconnect();
            } else {
                node.dispose();
            }
        }
        this.tracks.push(t);
    }
}

export const trackFactory = new TrackFactory();
